export default "__VITE_ASSET___n$1me7f__"